// "Type at least N characters" in the status line under a list header (PR D,
// flag clarityUx2Enabled): the line is rendered by useLogoSearchFeedback /
// useListSearchFeedback, far from the TableSearchBar that owns the input, so
// a click on it asks for focus through ONE window event instead of a prop
// drilled through FunctionalList and two hooks. Fire-and-forget: no listener
// (flag off, bar unmounted) = nothing happens.
export const LIST_SEARCH_FOCUS_EVENT = "kitmaker:focus-list-search";

export function requestListSearchFocus(): void {
  try {
    window.dispatchEvent(new CustomEvent(LIST_SEARCH_FOCUS_EVENT));
  } catch {
    // A UX nicety must never throw.
  }
}

export function subscribeListSearchFocus(listener: () => void): () => void {
  try {
    window.addEventListener(LIST_SEARCH_FOCUS_EVENT, listener);
    return () => window.removeEventListener(LIST_SEARCH_FOCUS_EVENT, listener);
  } catch {
    return () => undefined;
  }
}
